import React from 'react'
import Switch from '@mui/material/Switch';

export default function UiSwitch(props) {
    const {handleChange,checked,name,id,onClick} = props;

    return (
        <>
         <Switch
            id={id}
            name={name}
            checked={checked}
            onClick={onClick}
            onChange={handleChange}
            inputProps={{ 'aria-label': 'controlled' }}
        />
            
        </>
    )
}
